import styled from "styled-components";

export const GeneralContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
  overflow-y: auto;
  padding-bottom: 20px;

  .cards-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
  }

  .risk-card {
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border: 1px solid #eaebed;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    }

    &.critical {
      border: 1px solid #ff4d4f;
      background: #fff9f9;
    }

    &.high {
      border: 1px solid #ffc107;
      background: #fffdf5;
    }

    &.medium {
      border: 1px solid #2196f3;
      background: #f4f9ff;
    }

    &.low {
      border: 1px solid #4caf50;
      background: #f4fcf5;
    }

    .card-info {
      flex: 1;
      padding-right: 40px;

      .title {
        font-size: 20px;
        color: #3e3e5b;
        font-family: "Nunito Sans Bold";
      }

      .subtitle {
        margin: 0;
        font-size: 17px;
        color: #3e3e5b;
      }

      .warning-text {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        color: #707582;
        margin-top: 5px;

        .warning-text__icon {
          font-size: 13px;
          margin: auto 0;
          color: #3e3e5b;
        }
      }
    }

    .card-actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;

      .avatar-group {
        display: flex;
        align-items: center;

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px solid white;
          object-fit: cover;
          margin-left: -12px;

          &:first-child {
            margin-left: 0;
          }
        }

        .extra-count {
          margin-left: 8px;
          font-size: 17px;
          color: #3e3e5b;
        }
      }

      .view-all {
        font-size: 17px;
        color: #3e3e5b;
        text-decoration: none;
        cursor: pointer;
        background: transparent;
        border: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .summary-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #f8f9fa;
    padding: 16px 30px;
    border-radius: 24px;
    margin: 0 10px;

    .summary-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: #1f1f52;
      font-weight: 600;

      .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        display: inline-block;

        &.red {
          background: #ff4d4f;
        }
        &.yellow {
          background: #ffc107;
        }
        &.blue {
          background: #2196f3;
        }
        &.green {
          background: #4caf50;
        }
      }
    }
  }
`;
